import './dashboard_results_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.DashboardReviewView extends Monitoring.Views.DashboardResultsView
  template: JST["backbone/templates/monitoring/dashboard_review"]
  defaultSearchMethod: 'review'

  events: =>
    return _.extend({}, Monitoring.Views.DashboardResultsView.prototype.events, {
      'click .next_review_batch': 'done'
    })

  initialize: (@options = {}) ->
    super(@options)
    @limitTime = (Keepcon.currentAccount.dashboardSettings.review_mode_timeout_minutes || 0) * 60 * 1000
    @socialContentViews = []
    @eventAggregator.bind('onReviewCountUpdated', @onReviewCountUpdated)
    @batchSize = @accountSettings.batch_size

    @cameFromModerationDashboard = @options.cameFromModerationDashboard || false
    @moderatedBatchesCount       = 0
    @moderatedBatchesLimit       = @accountSettings.batches_limit
    @returnWhenEmptyQueue        = @accountSettings.return_when_empty_queue

  delayUrl: ->
    '/monitoring/dashboard/delay.json/'

  moderateAction: ->
    'moderate'

  doneAction: ->
    'done'

  _timeOut: =>
    # TODO: Disable timeout for now...
    @eventAggregator.trigger('clickOnMinimizeTab', @searchQuery.get('uuid'))
    console.log(moment(Date.now()).toString() + ": Timer triggered for session " + @searchQuery.get('uuid'))
    showError("Session '#{@searchQuery.get('name')}' was closed due to inactivity in the last #{@limitTime/60000} minutes", false)


  _initializeTimer: ->
    @_clearTimer()
    console.log(moment(Date.now()).toString() + ": Initialize timer for session " + @searchQuery.get('uuid'))
    @timer = setTimeout(@_timeOut, @limitTime)

  _clearTimer: ->
    unless @timer == undefined
      console.log(moment(Date.now()).toString() + ": Timer cleared for session " + @searchQuery.get('uuid'))
      clearTimeout(@timer)
      @timer = undefined

  onReviewCountUpdated: (uuid, counter) =>
    if @searchQuery.get('uuid') == uuid
      @$el.find('#results-count').html("#{counter}")
      @trigger('onReviewCountUpdated', counter)

  render: ->
    super()
    $('.monitoring-dashboard').addClass('review').removeClass('explore')
    @$resultsContainer.addClass('group-review')
    @$el.find('.top-nav-bar').remove() if @cameFromModerationDashboard
    @$el.find('#push-charts').remove() if @cameFromModerationDashboard
    @$el.find('.next_review_batch').parents('div').removeClass('hidden')
    @$el.find('#previous_results_link').addClass('hidden')
    return this

  newSearch: (searchQueryChanged=false) ->
    super(searchQueryChanged)
    @socialContentViews = []
    @batchCount = 0

  handleQueryResults: (dashboardResults, silent) =>
    if @mustRedirectToModerationDashboard(dashboardResults.values.length == 0)
      @redirectToModerationDashboard()
      return
    @_initializeTimer() if @limitTime > 0
    @$resultsContainer.empty()
    super(dashboardResults, silent)
    @trigger('searchCompleted', {})

  done: =>
    @nextBatchButtonEnabled(false)
    @_clearTimer()
    #exclude delayed content
    includedSocialContentViews = @socialContentViews.filter (socialContentView) ->
      !socialContentView.isExcluded
    excludedSocialContentViews = @socialContentViews.filter (socialContentView) ->
      socialContentView.isExcluded
    if excludedSocialContentViews.length > 0
      excludedSocialContentIds = excludedSocialContentViews.map (socialContentView) ->
        socialContentView.model.get('id')
      $.ajax
        url: @delayUrl()
        type: 'POST'
        data: {ids: excludedSocialContentIds, uuid: @searchQuery.get('uuid')}
        success: (response) =>
          console.log("Successfully delayed " + excludedSocialContentIds.length + " contents")
        error: () =>
          console.log("There was a problem trying to delay a content")
        dataType: 'json'

    # Create customer cases
    newCases = (content.getDataForNewCase() for content in @socialContentViews)
    data = {contents: newCases.filter (x) -> x != null}
    if data.contents.length > 0
      $.ajax({
        method: 'POST',
        url: '/customer/api/create_review.json',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify(data)
        success: (response) =>
          if (not response.success) and response.reason == 'conversations'
            showError(response.message)
        error: (response) =>
          showError("There was a problem trying to create conversations for some content")
      })
    if includedSocialContentViews.length > 0
      @moderateContents(includedSocialContentViews)
    else
      @getAfterDoneCallback()

  moderateContents: (socialContentViews) ->
    new Monitoring.Models.SocialContentModerator(socialContentViews, {uuid: @searchQuery.get('uuid')})
      .moderate(true, @getAfterDoneCallback(), @moderateAction())

  getAfterDoneCallback: =>
    if @mustRedirectToModerationDashboard()
      @redirectToModerationDashboard
    else
      @loadNextBatch

  loadNextBatch: =>
    @nextBatchButtonEnabled(true)
    @moderatedBatchesCount += 1
    visibleContentsCount = @socialContentViews.length
    Backbone.trigger('reviewQueueBatchConfirm')
    newlyReviewedContents = @socialContentViews.filter (socialContentView) ->
      !socialContentView.isExcluded
    newlyReviewedContentsCount = newlyReviewedContents.length
    @updateResultCount(parseInt(-newlyReviewedContentsCount))
    @socialContentViews = []
    @batchCount += 1
    window.scrollTo(0, 0)
    # Refresh everything after N batches to avoid problems!
    # Also refresh if there is the possibility of showing
    # there are no more contents and being wrong. There is
    # no other way to detect newly escalated contents, since
    # they are not percolated (they do not flow through the realtime bolt)
    if @batchCount >= 20 or visibleContentsCount < @batchSize
      @newSearch()
    else
      @searchWith(@doneAction(), false)
      @trigger('searchStarted')

  addOne: (socialContent, allTags, addFunction) =>
    view = Monitoring.Views.SocialContentViewFactory.create(socialContent, allTags, @currentUser, @accountSettings, @customerData)
    @socialContentViews.push(view)
    @addAndApplyEffect(view, addFunction)

  createRealtimeView: ->
    new Monitoring.Views.SocialContents.RealtimeReviewContentCheckerView(uuid: @searchQuery.get('uuid'), batchSize: @last_search_contents_taken)

  destroy: ->
    super()
    @_clearTimer()

  nextBatchButtonEnabled: (value) =>
    @$el.find('.next_review_batch').attr('disabled', !value)
    @$el.find('.next_review_batch').toggleClass('not-clickable')

  onResultsCount: (count) =>
    if count > 0
      @$el.find('#confirm_batch').show()
    else
      @$el.find('#confirm_batch').hide()

  isReviewQuery: =>
    return true

  mustRedirectToModerationDashboard: (queueIsEmpty = false) =>
    alternatives = [
      @batchesLimitReached(),
      @returnWhenEmptyQueue && queueIsEmpty
    ]
    @cameFromModerationDashboard && _.any(alternatives)

  batchesLimitReached: =>
    return false if @moderatedBatchesLimit == 0
    @moderatedBatchesCount >= @moderatedBatchesLimit

  redirectToModerationDashboard: =>
    @redirectTo('/moderation/dashboard')

  redirectTo: (url) ->
    location.href = url
